import axios from "axios";
import React, { useEffect, useState } from "react";
import Loading from "../../Extra/Loading";
import SMPdfGallery from "./SMPdfGallery";

const SMPDFPassengerAmt = ({ activeStation, sec }) => {
  const urlPrefix = process.env.REACT_APP_URL_STATION_MAPPING;

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [fetchedPdfData, setFetchedPdfData] = useState(null);

  //   https://railsetu.in:5000/getpdfDetails?reportType=Station%20mapping&&dept=Operating&&category=Mini%20Diagram&&sub_category=ET-JBP

  const fetchPdfData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${urlPrefix}getpassenger_amenities_pdfDetails?section=${sec}`,
      );
      if (response.data.status === "ok") {
        const data = response.data.data.map((obj) => {
          return {
            ...obj,
            pdf: `${urlPrefix}download_passenger_amenities_pdf/${obj.id}`,
          };
        });

        const filData = data.filter((o) => o.name === activeStation);
        setFetchedPdfData(filData);
      }
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
      setFetchedPdfData(null);
      setError(err.message);
    }
  };

  useEffect(() => {
    fetchPdfData();
  }, [activeStation, sec]);

  return (
    <div className="mt-2 ">
      {loading && <Loading />}

      {<SMPdfGallery data={fetchedPdfData} />}
    </div>
  );
};
export default SMPDFPassengerAmt;
